import React, { useState } from 'react';
import { T } from '../tema';
import { SAGSTYPER } from './Ui';
import { toast, pollAiOpgave, ANALYSERBARE_FILER, MAX_FIL_STOERRELSE, MAX_TOTAL_STOERRELSE, MAX_ANTAL_FILER } from '../utils';
// ── Moved from App.js: Notification system (PR5) ────────────────────
// ─────────────────────────────────────────────────────────
// NOTIFIKATIONS- OG PÅMINDELSESSYSTEM
// ─────────────────────────────────────────────────────────
// Notifikationstyper og deres egenskaber
const NOTIF_TYPER = {
 kritisk_deadline: {
 farve: "#ff6b6b", ikon: "", label: "Kritisk deadline",
 kræver_handling: true, kan_afvises: false,
 lyd: true,
 },
 deadline_overskredet: {
 farve: "#ff4444", ikon: "", label: "Deadline overskredet",
 kræver_handling: true, kan_afvises: false,
 lyd: true,
 },
 deadline_idag: {
 farve: "#ffd166", ikon: "", label: "Deadline i dag",
 kræver_handling: true, kan_afvises: false,
 lyd: true,
 },
 deadline_snart: {
 farve: "#f59e0b", ikon: "", label: "Deadline om 3 dage",
 kræver_handling: false, kan_afvises: true,
 lyd: false,
 },
 ny_haendelse: {
 farve: "#3fd4c7", ikon: "", label: "Ny hændelse",
 kræver_handling: false, kan_afvises: true,
 lyd: false,
 },
 risiko_flag: {
 farve: "#ff6b6b", ikon: "", label: "Sagsstyrke ændret",
 kræver_handling: true, kan_afvises: false,
 lyd: true,
 },
 dokument_godkendelse: {
 farve: "#c084fc", ikon: "", label: "Afventer godkendelse",
 kræver_handling: true, kan_afvises: false,
 lyd: false,
 },
 system: {
 farve: "#60a5fa", ikon: "", label: "System",
 kræver_handling: false, kan_afvises: true,
 lyd: false,
 },
};
// Demo notifikationer — i produktion kommer disse fra backend
// eslint-disable-next-line no-unused-vars
const DEMO_NOTIFIKATIONER = [
 {
 id: "n1", type: "deadline_overskredet",
 titel: "Deadline overskredet — Svar til Familieretshuset",
 besked: "SV-1003 · Christensen — Forældremyndighed\nFristen udløb for 2 dage siden. Handling påkrævet.",
 sag: "SV-1003", frist: "2026-04-06T10:00:00Z",
 handlinger: [
 { label: "Åbn sag", handling: "aaben_sag", primær: true },
 { label: "Registrér hændelse", handling: "ny_haendelse", primær: false },
 ],
 },
 {
 id: "n2", type: "deadline_idag",
 titel: "Deadline i dag — Partshøring sendes",
 besked: "SV-1001 · Andersen — Skilsmisse og bopæl\nDeadline er kl. 16:00 i dag.",
 sag: "SV-1001", frist: "2026-04-08T16:00:00Z",
 handlinger: [
 { label: "Åbn sag", handling: "aaben_sag", primær: true },
 { label: "Udsæt 1 dag", handling: "udsæt", primær: false },
 ],
 },
 {
 id: "n3", type: "dokument_godkendelse",
 titel: "Dokument afventer din godkendelse",
 besked: "Samværsaftale v2 · Nielsen\nAI-genereret udkast klar til gennemgang og godkendelse.",
 sag: "SV-1002",
 handlinger: [
 { label: "Godkend", handling: "godkend", primær: true },
 { label: "Åbn og gennemgå", handling: "aaben_dok", primær: false },
 ],
 },
 {
 id: "n4", type: "deadline_snart",
 titel: "Deadline om 3 dage — Klientmøde",
 besked: "SV-1002 · Nielsen — Samværsaftale\nMøde skal forberedes inden 11. april.",
 sag: "SV-1002", frist: "2026-04-11T10:00:00Z",
 handlinger: [
 { label: "Åbn sag", handling: "aaben_sag", primær: true },
 ],
 },
];
// ── Enkelt notifikations-popup ────────────────────────────
function NotifikationPopup({ notif, onHandling, onAfvis, onUdsæt, zIndex }) {
 const [shake, setShake] = useState(false);
 const [vis_udsæt, setVisUdsæt] = useState(false);
 const meta = NOTIF_TYPER[notif.type] || NOTIF_TYPER.system;
 const dato = notif.frist ? new Date(notif.frist) : null;
 const diff = dato ? Math.floor((dato - new Date()) / 86400000) : null;
 const forsøg_afvis = () => {
 if (!meta.kan_afvises) {
 setShake(true);
 setTimeout(() => setShake(false), 600);
 } else {
 onAfvis(notif.id);
 }
 };
 const UDSÆT_VALG = [
 { label: "1 time", minutter: 60 },
 { label: "3 timer", minutter: 180 },
 { label: "1 dag", minutter: 1440 },
 { label: "3 dage", minutter: 4320 },
 ];
 return (
 <div
 onClick={!meta.kan_afvises ? forsøg_afvis : undefined}
 className="sv-3d-tilt"
 style={{
 position: "relative",
 overflow: "hidden",
 background: `linear-gradient(135deg, rgba(10,14,46,0.97) 0%, rgba(15,20,60,0.97) 100%)`,
 border: `1px solid ${meta.farve}55`,
 borderLeft: `4px solid ${meta.farve}`,
 borderRadius: 14,
 padding: "18px 18px 16px",
 boxShadow: `0 8px 40px rgba(0,0,0,0.5), 0 0 20px ${meta.farve}18, inset 0 1px 0 rgba(255,255,255,0.06)`,
 backdropFilter: "blur(24px)",
 animation: shake
 ? "shake 0.5s cubic-bezier(.36,.07,.19,.97)"
 : "slideIn 0.35s cubic-bezier(0.34,1.56,0.64,1)",
 cursor: "default",
 userSelect: "none",
 }}>
 {/* Knapper øverst til højre */}
 {meta.kan_afvises && (
 <div style={{ position:"absolute", top:10, right:12, display:"flex", gap:6, alignItems:"center" }}>
 {/* Udsæt-knap */}
 <div style={{ position:"relative" }}> <button onClick={e=>{ e.stopPropagation(); setVisUdsæt(p=>!p); }} style={{
 background:"none", border:T.skillelinje,
 borderRadius:5, padding:"3px 8px", color:"#b0bec5",
 fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 }}>
 Udsæt
 </button>
 {vis_udsæt && (
 <div style={{
 position:"absolute", top:28, right:0, background:"rgba(10,14,46,0.98)",
 border:T.skillelinje, borderRadius:8,
 overflow:"hidden", zIndex:9999, minWidth:110,
 boxShadow:"0 8px 24px rgba(0,0,0,0.5)",
 }}>
 {UDSÆT_VALG.map(v => (
 <button key={v.label} onClick={e=>{ e.stopPropagation(); onUdsæt(notif.id, v.minutter); setVisUdsæt(false); }} style={{
 display:"block", width:"100%", textAlign:"left",
 background:"none", border:"none", borderBottom:T.skillelinje,
 padding:"9px 14px", color:"#cbd5e1", fontSize:12,
 cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 }}
 onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,0.07)"}
 onMouseOut={e=>e.currentTarget.style.background="none"}>
 {v.label}
 </button>
 ))}
 </div>
 )}
 </div>
 {/* Luk-knap */}
 <button onClick={e=>{ e.stopPropagation(); onAfvis(notif.id); }} style={{
 background:"none", border:"none",
 color:"#b0bec5", fontSize:18, lineHeight:1, padding:"2px 6px",
 cursor:"pointer", borderRadius:4, transition:"color 0.15s",
 }}
 onMouseOver={e=>e.currentTarget.style.color="rgba(230,221,220,0.8)"}
 onMouseOut={e=>e.currentTarget.style.color="#94a3b8"}>
 ×
 </button> </div>
 )}
 {/* Kræver handling — ingen luk-knap */}
 {!meta.kan_afvises && (
 <div style={{
 position:"absolute", top:10, right:12,
 fontSize:12, letterSpacing:"0.15em", textTransform:"uppercase",
 color: meta.farve, opacity:0.8,
 }}>
 Kræver handling
 </div>
 )}
 {/* Header */}
 <div style={{ display:"flex", gap:12, alignItems:"flex-start", marginBottom:10 }}> <div style={{
 width:38, height:38, borderRadius:10, flexShrink:0,
 background:`${meta.farve}18`, border:`1px solid ${meta.farve}33`,
 display:"flex", alignItems:"center", justifyContent:"center", fontSize:18,
 }}>
 {meta.ikon}
 </div> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:12, letterSpacing:"0.18em", textTransform:"uppercase", color:meta.farve, marginBottom:4 }}>
 {meta.label}
 </div> <div style={{ fontSize:"clamp(13px, 1.3vw, 15px)", color:"#e6dddc", fontWeight:500, lineHeight:1.3 }}>
 {notif.titel}
 </div> </div> </div>
 {/* Besked */}
 <div style={{
 fontSize:"clamp(12px, 1.1vw, 14px)", color:"rgba(230,221,220,0.7)", lineHeight:1.6,
 marginBottom:14, paddingLeft:50, whiteSpace:"pre-line",
 }}>
 {notif.besked}
 </div>
 {/* Tidsstempel / frist */}
 {dato && (
 <div style={{ paddingLeft:50, marginBottom:12 }}> <span style={{
 fontSize:12, letterSpacing:"0.08em",
 color: diff < 0 ? "#ff4444" : diff === 0 ? "#ffd166" : "rgba(230,221,220,0.95)",
 background: diff < 0 ? "rgba(255,68,68,0.18)" : diff === 0 ? "rgba(255,209,102,0.18)" : "rgba(255,255,255,0.06)",
 border: `1px solid ${diff < 0 ? "rgba(255,68,68,0.3)" : diff === 0 ? "rgba(255,209,102,0.3)" : "rgba(255,255,255,0.08)"}`,
 borderRadius:4, padding:"3px 8px",
 }}>
 {diff < 0 ? ` ${Math.abs(diff)} dage overskredet` : diff === 0 ? " Udløber i dag" : ` ${diff} dage tilbage`}
 </span> </div>
 )}
 {/* Handlingsknapper */}
 {notif.handlinger && (
 <div style={{ display:"flex", gap:8, paddingLeft:50, flexWrap:"wrap" }}>
 {notif.handlinger.map((h,i) => (
 <button key={i} onClick={()=>onHandling(notif.id, h.handling, notif.sag_id || notif.sag)} style={{
 background: h.primær ? meta.farve : "rgba(255,255,255,0.07)",
 border: h.primær ? "none" : T.skillelinje,
 borderRadius:7, padding:"8px 16px",
 color: h.primær ? "#ffffff" : "rgba(230,221,220,0.8)",
 fontSize:12, fontWeight: h.primær ? 700 : 400,
 fontFamily:"Roboto, sans-serif",
 cursor:"pointer", transition:"all 0.15s",
 }}
 onMouseOver={e=>{ if(!h.primær) e.currentTarget.style.background="rgba(255,255,255,0.06)"; }}
 onMouseOut={e=>{ if(!h.primær) e.currentTarget.style.background="rgba(255,255,255,0.07)"; }}>
 {h.label}
 </button>
 ))}
 </div>
 )}
 </div>
 );
}
// ── Import Wizard — browser-baseret sagsimport ───────────
function ImportWizard({ onFærdig, onAnnuller, kørImport }) {
 const [trin, setTrin] = useState(1); // 1=vælg filer, 2=AI analyserer, 3=bekræft info, 4=importerer
 const [filer, setFiler] = useState([]);
 const [forslag, setForslag] = useState(null);
 const [fil_data, setFilData] = useState([]);
 const [fornavn, setFornavn] = useState("");
 const [efternavn, setEffternavn] = useState("");
 const [sagsnummer, setSagsnummer] = useState("");
 const [sag_type, setSagType] = useState("skilsmisse");
 const [sag_status, setSagStatus] = useState("aktiv");
 const [status_tekst, setStatusTekst] = useState("");
 const [progress, setProgress] = useState(0);
 const [fejl, setFejl] = useState(null);
 const [advarsler, setAdvarsler] = useState([]);
 const file_ref = React.useRef(null);
 const input_stil = { width:"100%", background:"rgba(8,12,30,0.65)", border:"1px solid rgba(255,255,255,0.09)", borderRadius:9, padding:"10px 14px", color:"#e2e8f0", fontSize:14, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", marginBottom:12, colorScheme:"dark", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", transition:"border-color 0.2s, box-shadow 0.2s", outline:"none" };
 // Trin 1 → 2: Upload filer til analyse
 const start_analyse = async () => {
 if (filer.length === 0) return;
 setTrin(2);
 setStatusTekst("Sender filer til AI-analyse...");
 setProgress(10);
 setFejl(null);
 try {
 const sorteret = [...filer].sort((a, b) => {
 const p = n => { n = n.toLowerCase();
 if (n.includes('fuldmagt')) return 0;
 if (n.includes('skilsmissevej')) return 1;
 if (n.endsWith('.docx')) return 3;
 if (n.endsWith('.pdf')) return 4;
 return 10; };
 return p(a.name) - p(b.name);
 });
 const formData = new FormData();
 let _upload_total = 0;
 for (const fil of sorteret) {
 if (/\.zip$/i.test(fil.name)) continue;
 if (!ANALYSERBARE_FILER.test(fil.name) || fil.size > MAX_FIL_STOERRELSE) continue;
 if (_upload_total + fil.size > MAX_TOTAL_STOERRELSE) continue;
 if (formData.getAll("filer").length >= MAX_ANTAL_FILER) continue;
 try {
 const buf = fil.size > 0 ? await fil.arrayBuffer() : new ArrayBuffer(0);
 formData.append("filer", new Blob([buf], {type: fil.type || 'application/octet-stream'}), fil.webkitRelativePath || fil.name);
 _upload_total += fil.size;
 } catch (e) { console.warn('[IMPORT] Springer over (laasefejl):', fil.webkitRelativePath || fil.name); continue; }
 }
 console.log('[IMPORT] Klar (indlaest i hukommelse): ' + formData.getAll("filer").length + ' filer, ' + Math.round(_upload_total/1024/1024) + 'MB');
 if (_upload_total === 0) {
 setFejl("Ingen analysérbare filer fundet. Mappen skal indeholde mindst én PDF, DOCX, DOC, EML, TXT eller MSG-fil under 50 MB. " + sorteret.length + " filer i mappen — alle filtreret fra.");
 setStatusTekst("Ingen analysérbare filer fundet");
 return;
 }
 setProgress(30);
 setStatusTekst('Uploader ' + formData.getAll("filer").length + ' filer...');
 const data = await new Promise((resolve, reject) => {
 const xhr = new XMLHttpRequest();
 xhr.open('POST', (window.SV_API || '/api/') + 'import/behandl');
 xhr.withCredentials = true;
 xhr.timeout = 600000;
 xhr.upload.onprogress = (e) => {
 if (e.lengthComputable) {
 const pct = Math.round((e.loaded / e.total) * 100);
 setProgress(30 + Math.round(pct * 0.3));
 setStatusTekst('Uploader filer... ' + pct + '%');
 }
 };
 xhr.onload = () => {
 if (xhr.status >= 200 && xhr.status < 300) {
 try { resolve(JSON.parse(xhr.responseText)); }
 catch (_) { reject(new Error('Serverfejl: Ugyldig respons fra server')); }
 } else {
 reject(new Error('Analyse fejlede: ' + xhr.status));
 }
 };
 xhr.onerror = () => {
 reject(new Error('Netvaerksfejl (readyState ' + xhr.readyState + ') — prøv igen'));
 };
 xhr.ontimeout = () => {
 reject(new Error('Timeout: Upload tog for lang tid (10 min granse)'));
 };
 xhr.send(formData);
 });
 if (data.fejl) throw new Error(data.fejl);
 setFilData(data.fil_data || []);
 setAdvarsler(data.advarsler || []);
 setProgress(70);
 setStatusTekst("AI-analyse behandles — vises automatisk når klar...");
 pollAiOpgave(data.opgave_id, (resultat) => {
 if (resultat?._advarsler_ai?.length) setAdvarsler(prev => [...prev, ...resultat._advarsler_ai]);
 setForslag(resultat);
 setFornavn(resultat?.fornavn || "");
 setEffternavn(resultat?.efternavn || "");
 setSagsnummer(resultat?.sagsnummer || "");
 setProgress(100);
 setStatusTekst("Analyse fuldført");
 setTimeout(() => setTrin(3), 500);
 }, (err) => {
 setFejl("Analyse fejlede — " + (err?.message || "prøv igen"));
 setStatusTekst("Analyse fejlede");
 }, 'import/opgave/');
 } catch (e) {
 console.error('[ImportWizard] analyse fejl:', e);
 setFejl("Analyse fejlede: " + (e?.message || "tjek din forbindelse og prøv igen"));
 setStatusTekst("Analyse fejlede");
 }
 };
 // Trin 3 → 4: Importér — afleverer til App-niveau og navigerer væk
 const start_import = async () => {
 if (!fornavn.trim()) { toast("Indtast venligst et fornavn", "fejl"); return; }
 const formData = new FormData();
 let _imp_total = 0;
 for (const fil of filer) {
 if (/\.zip$/i.test(fil.name)) continue;
 if (!ANALYSERBARE_FILER.test(fil.name) || fil.size > MAX_FIL_STOERRELSE) continue;
 if (_imp_total + fil.size > MAX_TOTAL_STOERRELSE) continue;
 if (formData.getAll("filer").length >= MAX_ANTAL_FILER) continue;
 try {
 const buf = fil.size > 0 ? await fil.arrayBuffer() : new ArrayBuffer(0);
 formData.append("filer", new Blob([buf], {type: fil.type || 'application/octet-stream'}), fil.webkitRelativePath || fil.name);
 _imp_total += fil.size;
 } catch (e) { console.warn('[IMPORT] start_import: springer over:', fil.webkitRelativePath || fil.name); }
 }
 formData.append("fornavn", fornavn.trim());
 formData.append("efternavn", efternavn.trim());
 formData.append("sagsnummer_input", sagsnummer.trim());
 formData.append("sag_type", sag_type);
 formData.append("sag_status", sag_status);
 if (forslag?.adresse) formData.append("adresse", forslag.adresse);
 if (forslag?.telefon) formData.append("telefon", forslag.telefon);
 if (forslag?.email) formData.append("email", forslag.email);
 if (forslag?.modpart_navn) formData.append("modpart_navn", forslag.modpart_navn);
 if (forslag?.børn?.length) formData.append("boern_json", JSON.stringify(forslag.børn));
 if (forslag?.noter) formData.append("noter", forslag.noter);
 const kategorier = {};
 const datoer = {};
 const resuméer = {};
 const fil_navne = {};
 fil_data.forEach(fd => {
 kategorier[fd.originalname] = fd.kategori;
 if (fd.dato) datoer[fd.originalname] = fd.dato;
 if (fd.resumé) resuméer[fd.originalname] = fd.resumé;
 if (fd.ai_navn) fil_navne[fd.originalname] = fd.ai_navn;
 });
 formData.append("fil_kategorier", JSON.stringify(kategorier));
 formData.append("fil_datoer", JSON.stringify(datoer));
 formData.append("fil_resuméer", JSON.stringify(resuméer));
 formData.append("fil_navne", JSON.stringify(fil_navne));
 const klient_label = fornavn.trim() + " " + (efternavn || "").trim();
 // Aflever til App-niveau — kører uafhængigt af denne komponent
 kørImport(formData, klient_label);
 toast("Import startet for " + klient_label + " — du kan arbejde videre", "succes");
 onFærdig();
 };
 const TRIN_LABELS = ["Vælg filer", "AI analyserer", "Bekræft og importér"];
 return (
 <div style={{ padding:"clamp(16px, 3vw, 28px) clamp(16px, 4vw, 40px)", maxWidth:800, margin:"0 auto", position:"relative", zIndex:1 }}>
 {/* Trin-indikator */}
 <div style={{ display:"flex", gap:4, marginBottom:28 }}>
 {TRIN_LABELS.map((label, i) => (
 <div key={i} style={{ flex:1, textAlign:"center" }}> <div style={{
 height:4, borderRadius:2, marginBottom:6,
 background: i+1 <= trin ? T.turkis : "rgba(255,255,255,0.08)",
 transition:"background 0.3s ease",
 }} /> <span style={{ fontSize:12, color: i+1 <= trin ? T.turkis : T.dæmpet, fontWeight: i+1 === trin ? 600 : 400 }}>{label}</span> </div>
 ))}
 </div>
 {/* ── TRIN 1: Vælg filer ── */}
 {trin === 1 && (
 <div style={{ animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <div style={{
 background:"rgba(8,12,30,0.55)", border:"2px dashed rgba(63,212,199,0.2)", borderRadius:16,
 padding:"40px 20px", textAlign:"center", cursor:"pointer", transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)",
 backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)",
 marginBottom:20,
 }}
 onClick={() => file_ref.current?.click()}
 onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = T.turkis; }}
 onDragLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)"; }}
 onDrop={e => {
 e.preventDefault();
 e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
 const items = e.dataTransfer.items;
 if (items) {
 const alle = [];
 for (let i = 0; i < items.length; i++) {
 if (items[i].kind === "file") alle.push(items[i].getAsFile());
 }
 if (alle.length > 0) setFiler(alle);
 }
 }}> <input ref={file_ref} type="file" webkitdirectory="" directory="" multiple
 style={{ display:"none" }}
 onChange={e => { if (e.target.files?.length) setFiler(Array.from(e.target.files)); }} /> <span style={{ fontSize:48, display:"block", marginBottom:12 }}></span> <div style={{ fontSize:16, color:T.creme, fontWeight:500, marginBottom:8 }}>
 {filer.length > 0 ? filer.length + " filer valgt" : "Vælg sagsmappe fra din PC"}
 </div> <div style={{ fontSize:13, color:T.dæmpet }}>
 Klik her eller træk en mappe ind — alle filer importeres til OneDrive
 </div> </div>
 {filer.length === 0 && (
 <button onClick={onAnnuller} style={{ width:"100%", padding:"12px", borderRadius:8, background:"rgba(255,255,255,0.04)", border:T.skillelinje, color:T.dæmpet, fontSize:14, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", marginBottom:16 }}>Annuller</button>
 )}
 {filer.length > 0 && (
 <> <div style={{ background:"rgba(8,12,30,0.55)", borderRadius:12, border:"1px solid rgba(255,255,255,0.07)", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)", padding:16, marginBottom:20, maxHeight:300, overflowY:"auto" }}> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8, textTransform:"uppercase", letterSpacing:"0.1em" }}>Filer ({filer.length})</div>
 {filer.map((f, i) => (
 <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom: i < filer.length-1 ? T.skillelinje : "none" }}> <span style={{ fontSize:13, color:T.creme, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"70%" }}>
 {f.webkitRelativePath || f.name}
 </span> <span style={{ fontSize:12, color:T.dæmpet }}>
 {f.size < 1024*1024 ? Math.round(f.size/1024) + " KB" : (f.size/(1024*1024)).toFixed(1) + " MB"}
 </span> </div>
 ))}
 </div> <div style={{ display:"flex", gap:10 }}> <button onClick={onAnnuller} style={{ flex:1, padding:"12px", borderRadius:8, background:"rgba(255,255,255,0.04)", border:T.skillelinje, color:T.dæmpet, fontSize:14, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Annuller</button> <button onClick={start_analyse} style={{ flex:2, padding:"12px", borderRadius:8, background:T.turkis, border:"none", color:"#0c0f1a", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Analysér filer med AI
 </button> </div> </>
 )}
 </div>
 )}
 {/* ── TRIN 2: AI analyserer ── */}
 {trin === 2 && (
 <div style={{ animation:"fadeUp 0.3s ease", textAlign:"center", padding:"40px 0" }}> <div style={{ width:48, height:48, border:"3px solid "+T.turkis, borderTopColor:"transparent", borderRadius:"50%", animation:"spin 1s linear infinite", margin:"0 auto 20px" }} /> <div style={{ fontSize:16, color:T.creme, fontWeight:500, marginBottom:8 }}>{status_tekst}</div> <div style={{ fontSize:13, color:T.dæmpet, marginBottom:20 }}>AI læser dokumenterne og udtrækker klientinformation...</div>
 {/* Progress bar */}
 <div style={{ width:"100%", maxWidth:400, height:6, background:"rgba(255,255,255,0.06)", borderRadius:3, margin:"0 auto", overflow:"hidden" }}> <div style={{ width:progress+"%", height:"100%", background:T.turkis, borderRadius:3, transition:"width 0.5s ease" }} /> </div>
 {advarsler.length > 0 && (
 <div style={{ marginTop:20, padding:"12px 16px", background:"rgba(234,179,8,0.1)", border:"1px solid rgba(234,179,8,0.35)", borderRadius:8, textAlign:"left" }}> <div style={{ fontSize:13, color:"#eab308", fontWeight:600, marginBottom:6 }}>Følgende filer kunne ikke læses og er sprunget over i analysen — tjek dem manuelt:</div>
 {advarsler.map((a, i) => <div key={i} style={{ fontSize:12, color:"#fde047", marginTop:3 }}>• {a}</div>)}
 </div>
 )}
 {fejl && (
 <div style={{ marginTop:20, padding:"12px 16px", background:"rgba(255,107,107,0.1)", border:"1px solid rgba(255,107,107,0.3)", borderRadius:8 }}> <div style={{ fontSize:13, color:"#ff6b6b" }}>{fejl}</div> <button onClick={() => { setTrin(1); setFejl(null); }} style={{ marginTop:8, padding:"8px 16px", borderRadius:6, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.1)", color:T.creme, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Prøv igen</button> </div>
 )}
 </div>
 )}
 {/* ── TRIN 3: Bekræft info ── */}
 {trin === 3 && (
 <div style={{ animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <div style={{ background:"rgba(63,212,199,0.06)", border:"1px solid rgba(63,212,199,0.15)", borderRadius:12, padding:16, marginBottom:20 }}> <div style={{ fontSize:13, color:T.turkis, fontWeight:600, marginBottom:4 }}>AI har analyseret {fil_data.length} filer</div> <div style={{ fontSize:12, color:T.dæmpet }}>Bekræft eller ret klientoplysningerne herunder</div> </div>
 {advarsler.length > 0 && (
 <div style={{ padding:"12px 16px", background:"rgba(234,179,8,0.1)", border:"1px solid rgba(234,179,8,0.35)", borderRadius:8, marginBottom:16 }}> <div style={{ fontSize:13, color:"#eab308", fontWeight:600, marginBottom:6 }}>Følgende filer kunne ikke læses og er sprunget over i analysen — tjek dem manuelt:</div>
 {advarsler.map((a, i) => <div key={i} style={{ fontSize:12, color:"#fde047", marginTop:3 }}>• {a}</div>)}
 </div>
 )}
 <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}> <div> <label style={{ fontSize:12, color:T.dæmpet, display:"block", marginBottom:4 }}>Fornavn *</label> <input value={fornavn} onChange={e=>setFornavn(e.target.value)} style={input_stil} placeholder="Klientens fornavn" /> </div> <div> <label style={{ fontSize:12, color:T.dæmpet, display:"block", marginBottom:4 }}>Efternavn</label> <input value={efternavn} onChange={e=>setEffternavn(e.target.value)} style={input_stil} placeholder="Klientens efternavn" /> </div> </div> <div style={{ marginBottom:16 }}> <label style={{ fontSize:12, color:T.dæmpet, display:"block", marginBottom:4 }}>Sagsnummer (valgfrit — genereres automatisk hvis tomt)</label> <input value={sagsnummer} onChange={e=>setSagsnummer(e.target.value)} style={input_stil} placeholder="Fx 27571436-01 eller SV-1001" /> </div> <div style={{ marginBottom:16 }}> <label style={{ fontSize:12, color:T.dæmpet, display:"block", marginBottom:8 }}>Sagstype *</label> <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
 {SAGSTYPER.map(st => (
 <button key={st.v} onClick={()=>setSagType(st.v)} style={{
 padding:"8px 14px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 border: sag_type===st.v ? "2px solid "+T.turkis : T.kort_kant,
 background: sag_type===st.v ? T.turkis+"18" : "rgba(255,255,255,0.04)",
 color: sag_type===st.v ? T.turkis : T.dæmpet, fontWeight: sag_type===st.v ? 700 : 400,
 }}>{st.l}</button>
 ))}
 </div> </div> <div style={{ marginBottom:16 }}> <label style={{ fontSize:12, color:T.dæmpet, display:"block", marginBottom:8 }}>Status</label> <div style={{ display:"flex", gap:8 }}> <button onClick={()=>setSagStatus("aktiv")} style={{
 flex:1, padding:"10px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 border: sag_status==="aktiv" ? "2px solid "+T.turkis : T.kort_kant,
 background: sag_status==="aktiv" ? T.turkis+"18" : "rgba(255,255,255,0.04)",
 color: sag_status==="aktiv" ? T.turkis : T.dæmpet, fontWeight: sag_status==="aktiv" ? 700 : 400,
 }}>Aktiv sag</button> <button onClick={()=>setSagStatus("lukket")} style={{
 flex:1, padding:"10px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 border: sag_status==="lukket" ? "2px solid #60a5fa" : T.kort_kant,
 background: sag_status==="lukket" ? "rgba(96,165,250,0.1)" : "rgba(255,255,255,0.04)",
 color: sag_status==="lukket" ? "#60a5fa" : T.dæmpet, fontWeight: sag_status==="lukket" ? 700 : 400,
 }}>Lukket/arkiv</button> </div> </div>
 {/* AI-fundet info */}
 {forslag && (forslag.modpart_navn || forslag.børn?.length > 0 || forslag.adresse) && (
 <div style={{ background:"rgba(8,12,30,0.5)", borderRadius:12, border:"1px solid rgba(63,212,199,0.12)", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)", padding:16, marginBottom:16 }}> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8, textTransform:"uppercase", letterSpacing:"0.1em" }}>Fundet af AI</div>
 {forslag.modpart_navn && <div style={{ fontSize:13, color:T.creme, marginBottom:4 }}>Modpart: {forslag.modpart_navn}</div>}
 {forslag.adresse && <div style={{ fontSize:13, color:T.creme, marginBottom:4 }}>Adresse: {forslag.adresse}</div>}
 {forslag.telefon && <div style={{ fontSize:13, color:T.creme, marginBottom:4 }}>Telefon: {forslag.telefon}</div>}
 {forslag.email && <div style={{ fontSize:13, color:T.creme, marginBottom:4 }}>Email: {forslag.email}</div>}
 {forslag.børn?.length > 0 && <div style={{ fontSize:13, color:T.creme }}>Børn: {forslag.børn.map(b=>b.navn).join(", ")}</div>}
 </div>
 )}
 {/* Fil-oversigt med kategorier */}
 <div style={{ background:"rgba(8,12,30,0.55)", borderRadius:12, border:"1px solid rgba(255,255,255,0.07)", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)", padding:16, marginBottom:20, maxHeight:250, overflowY:"auto" }}> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8, textTransform:"uppercase", letterSpacing:"0.1em" }}>Filer der importeres ({fil_data.length})</div>
 {fil_data.map((fd, i) => (
 <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"5px 0", borderBottom: i < fil_data.length-1 ? T.skillelinje : "none" }}> <span style={{ fontSize:13, color:T.creme, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"50%" }}>
 {fd.ai_navn || fd.originalname}
 </span> <div style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}>
 {fd.størrelse != null && <span style={{ fontSize:11, color:T.dæmpet }}>{fd.størrelse < 1048576 ? Math.round(fd.størrelse/1024)+" KB" : (fd.størrelse/1048576).toFixed(1)+" MB"}</span>}
 <span style={{ fontSize:12, color:T.turkis, background:"rgba(63,212,199,0.1)", padding:"2px 8px", borderRadius:4 }}>{fd.kategori}</span> </div> </div>
 ))}
 </div> <div style={{ display:"flex", gap:10 }}> <button onClick={() => { setTrin(1); setFejl(null); }} style={{ flex:1, padding:"12px", borderRadius:8, background:"rgba(255,255,255,0.04)", border:T.skillelinje, color:T.dæmpet, fontSize:14, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Tilbage</button> <button onClick={start_import} disabled={!fornavn.trim()} style={{
 flex:2, padding:"12px", borderRadius:8, background: fornavn.trim() ? T.turkis : "rgba(255,255,255,0.04)",
 border:"none", color: fornavn.trim() ? "#0c0f1a" : T.dæmpet, fontWeight:700, fontSize:14,
 cursor: fornavn.trim() ? "pointer" : "default", fontFamily:"'Inter',system-ui,sans-serif",
 opacity: fornavn.trim() ? 1 : 0.5,
 }}>
 Importér sag — du bliver sagsbehandler
 </button> </div> </div>
 )}
 {/* Trin 4 fjernet — import kører i baggrunden via statusbar i bunden */}
 </div>
 );
}
// ── Notifikationscenter — stakket visning ─────────────────
function NotifikationsCenter({ notifikationer, onHandling, onAfvis, onUdsæt, onLukAlle }) {
 const [udvidet, setUdvidet] = useState(true);
 const kræver_handling = notifikationer.filter(n => !NOTIF_TYPER[n.type]?.kan_afvises);
 const kan_afvises = notifikationer.filter(n => NOTIF_TYPER[n.type]?.kan_afvises);
 const total = notifikationer.length;
 if (total === 0) return null;
 return (
 <div style={{
 position: "fixed",
 top: 0, left: 0, right: 0, bottom: 0,
 zIndex: 1000,
 display: "flex",
 flexDirection: "column",
 pointerEvents: "none",
 }}>
 {/* Notifikations-stak */}
 <div style={{
 position: "absolute",
 top: 60, right: 0,
 width: "min(480px, 100vw)",
 maxHeight: "calc(100vh - 60px)",
 overflowY: "auto",
 padding: "16px",
 pointerEvents: "all",
 display: "flex",
 flexDirection: "column",
 gap: 10,
 }}>
 {/* Header — antal og luk-alle */}
 <div style={{
 display:"flex", justifyContent:"space-between", alignItems:"center",
 padding:"10px 14px",
 background:"rgba(8,12,30,0.92)", border:"1px solid rgba(255,255,255,0.08)",
 borderRadius:12, backdropFilter:"blur(24px)", WebkitBackdropFilter:"blur(24px)",
 boxShadow:"0 4px 24px rgba(0,0,0,0.4)",
 }}> <div style={{ display:"flex", alignItems:"center", gap:10 }}> <div style={{ position:"relative" }}> <div style={{
 width:26, height:26, borderRadius:"50%",
 background: kræver_handling.length > 0
 ? "linear-gradient(135deg, #ff6b6b, #ff4444)"
 : "linear-gradient(135deg, #ffd166, #ffb800)",
 display:"flex", alignItems:"center", justifyContent:"center",
 fontSize:12, fontWeight:700, color:"#ffffff",
 boxShadow: kræver_handling.length > 0
 ? "0 0 12px rgba(255,107,107,0.6), 0 0 4px rgba(255,107,107,0.3)"
 : "0 0 8px rgba(255,209,102,0.4)",
 animation: kræver_handling.length > 0 ? "pulse 1.5s infinite" : "none",
 }}>
 {total}
 </div> </div> <span style={{ fontSize:12, color:"rgba(230,221,220,0.85)", letterSpacing:"0.06em", fontWeight:500 }}>
 {kræver_handling.length > 0
 ? `${kræver_handling.length} kræver handling`
 : `${total} notifikation${total>1?"er":""}`}
 </span> </div> <div style={{ display:"flex", gap:6 }}> <button onClick={()=>setUdvidet(p=>!p)} style={{
 background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)",
 borderRadius:7, padding:"4px 10px", color:"rgba(230,221,220,0.8)", fontSize:11,
 cursor:"pointer", transition:"all 0.15s", letterSpacing:"0.05em",
 }}
 onMouseOver={e=>{ e.currentTarget.style.background="rgba(255,255,255,0.09)"; e.currentTarget.style.color="rgba(230,221,220,0.95)"; }}
 onMouseOut={e=>{ e.currentTarget.style.background="rgba(255,255,255,0.05)"; e.currentTarget.style.color="rgba(230,221,220,0.8)"; }}>
 {udvidet ? "▲ Skjul" : "▼ Vis"}
 </button>
 {kan_afvises.length > 0 && kan_afvises.length === total && (
 <button onClick={onLukAlle} style={{
 background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)",
 borderRadius:7, padding:"4px 10px", color:"rgba(230,221,220,0.8)", fontSize:11,
 cursor:"pointer", transition:"all 0.15s",
 }}
 onMouseOver={e=>{ e.currentTarget.style.background="rgba(255,255,255,0.09)"; }}
 onMouseOut={e=>{ e.currentTarget.style.background="rgba(255,255,255,0.05)"; }}>
 Luk alle
 </button>
 )}
 </div> </div>
 {/* Kritiske (kræver handling) — vises altid */}
 {kræver_handling.map((n, i) => (
 <NotifikationPopup key={n.id} notif={n} onHandling={onHandling} onAfvis={onAfvis} onUdsæt={onUdsæt} zIndex={1000-i} />
 ))}
 {/* Ikke-kritiske — kan skjules */}
 {udvidet && kan_afvises.map((n, i) => (
 <NotifikationPopup key={n.id} notif={n} onHandling={onHandling} onAfvis={onAfvis} onUdsæt={onUdsæt} zIndex={900-i} />
 ))}
 </div> </div>
 );
}
// ─────────────────────────────────────────────────────────
export { NOTIF_TYPER, NotifikationPopup, ImportWizard, NotifikationsCenter };